import { Dialog } from "primereact/dialog";
import { TPipeline } from "./modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Fetch } from "../../utilities/fetch";

interface Iprops {
    data?: TPipeline,
    open: boolean,
    hideDialog: () => void
}

interface IHistory {
    statusId: number;
    statusName: string;
    createdOn: string;
    createdBy: string;
    comment?: string;
}

export const PipelineHistory = (props: Iprops) => {
    const [history, setHistory] = useState<{ data: IHistory[], loading: boolean }>({ data: [], loading: false });

    const onHide = () => {
        props.hideDialog();
    }

    async function loadHistory(submissionId: number) {
        setHistory({ data: [], loading: true });
        const data = await Fetch<IHistory[]>(`pipeline/history/${submissionId}`);
        if (data) {
            setHistory({ data: data, loading: false });
        }
        else setHistory({ data: [], loading: false });
    }

    useEffect(() => {
        if (props.open && props.data?.submissionId) {
            loadHistory(props.data.submissionId);
        }
    }, [props.open, props.data?.submissionId]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`Pipeline Status History for ${props.data?.candidateName}`} modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" value={history.data} loading={history.loading}>
                <Column field="sn" header="S.No" body={(r: IHistory, { rowIndex }: any) => rowIndex + 1} />
                <Column field="statusName" header="Status" />
                <Column field="createdBy" header="Created By" />
                <Column field="createdOn" header="Created On" body={(r: IHistory) => format(new Date(r.createdOn + 'z'), "MM-dd-yyyy hh:mm a")} />
                <Column field="comment" header="Comment" />
            </DataTable>
        </Dialog>
    );
}